/* La Meilleure Partie : « Composer ma box ».
   Règles : 5 sachets minimum (Découverte) ; dès 18 sachets : livraison offerte et 2,89 € le sachet ;
   dès 24 sachets : 2,79 € le sachet. Les remises sont des réductions automatiques Shopify (-0,10 € / -0,20 € par sachet) :
   ce script ne fait que les afficher. La progression parle en sachets restants. */
(function () {
  var MIN = 5, FREE = 18, BIG = 24, STORE_KEY = 'lmp-box-v2';
  var OFF = { 18: 10, 24: 20 }; // remise par sachet, en centimes

  function fmt(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function plural(n) { return n + (n > 1 ? ' sachets' : ' sachet'); }
  function tierOf(n) { return n >= BIG ? 2 : (n >= FREE ? 1 : 0); }
  function offOf(n) { return n >= BIG ? OFF[24] : (n >= FREE ? OFF[18] : 0); }

  function init(root) {
    if (root.dataset.ready) return;
    var dataEl = root.querySelector('[data-lmp-box-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.ready = '1';

    var F = data.flavors;
    var byId = {};
    F.forEach(function (f) { byId[f.id] = f; });
    var available = F.filter(function (f) { return f.max > 0; });
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var items = [];
    var lastAdded = -1;

    function count(id) { return items.filter(function (x) { return x === id; }).length; }
    function canAdd(id) { var f = byId[id]; return !!f && count(id) < f.max; }

    function fill(k, random) {
      var out = [], guard = 0;
      var tally = {};
      while (out.length < k && available.length && guard < 500) {
        var f = random ? available[Math.floor(Math.random() * available.length)] : available[out.length % available.length];
        if ((tally[f.id] || 0) < f.max) { out.push(f.id); tally[f.id] = (tally[f.id] || 0) + 1; }
        guard++;
      }
      return out;
    }

    function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(items)); } catch (e) {} }
    function load() {
      try {
        var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
        if (Array.isArray(saved)) {
          var tally = {};
          return saved.filter(function (id) {
            if (!byId[id]) return false;
            tally[id] = (tally[id] || 0) + 1;
            return tally[id] <= byId[id].max;
          });
        }
      } catch (e) {}
      return null;
    }

    var celebrateTimer;
    function setItems(next, animateIndex) {
      var up = tierOf(next.length) > tierOf(items.length);
      var tier = tierOf(next.length);
      items = next;
      lastAdded = typeof animateIndex === 'number' ? animateIndex : -1;
      save();
      render();
      var cel = $('[data-celebrate]');
      if (up) {
        cel.textContent = tier === 2 ? 'Palier débloqué : 2,79 € le sachet !' : 'Palier débloqué : point relais offert et 2,89 € le sachet !';
        cel.hidden = false;
        rain();
        clearTimeout(celebrateTimer);
        celebrateTimer = setTimeout(function () { cel.hidden = true; }, 5000);
      } else if (tierOf(next.length) < 1) {
        cel.hidden = true;
      }
    }

    function rain() {
      var box = $('[data-confetti]');
      if (!box || !data.confetti.length) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      box.innerHTML = '';
      for (var i = 0; i < 18; i++) {
        var img = document.createElement('img');
        img.src = data.confetti[i % data.confetti.length];
        img.alt = '';
        img.style.left = (3 + (i * 37) % 90) + '%';
        img.style.animationDelay = ((i * 0.11) % 0.9).toFixed(2) + 's';
        box.appendChild(img);
      }
      setTimeout(function () { box.innerHTML = ''; }, 3200);
    }

    // Téléphone : message posé sur la box après le choix d'une taille (n = 0 : on le ferme)
    function sizeNote(n) {
      var note = $('[data-sizenote]');
      if (!note) return;
      if (!n || !(window.matchMedia && window.matchMedia('(max-width: 989px)').matches)) { note.hidden = true; return; }
      $('[data-sizenote-title]').textContent = n <= MIN ? 'Une saveur de chaque !' : 'Votre box de ' + n + ' est prête !';
      $('[data-sizenote-text]').textContent = n <= MIN
        ? 'On a mis un sachet de chaque saveur. Rien n’est figé : juste en dessous, changez les saveurs avec + et −.'
        : 'On l’a remplie à parts égales. Rien n’est figé : juste en dessous, choisissez vos saveurs et vos quantités avec + et −, autant que vous voulez.';
      note.hidden = false;
    }

    function inc(id) {
      if (!canAdd(id)) return;
      sizeNote(0);
      setItems(items.concat([id]), items.length);
    }
    function dec(id) {
      sizeNote(0);
      var idx = items.lastIndexOf(id);
      if (idx < 0) return;
      var next = items.slice();
      next.splice(idx, 1);
      setItems(next);
    }

    function render() {
      var n = items.length;
      var full = items.reduce(function (s, id) { return s + byId[id].price; }, 0);
      var off = offOf(n);
      var total = full - off * n;

      // Box (18 ou 24 cases)
      var cap = n <= FREE ? FREE : BIG;
      var slots = $('[data-slots]');
      var html = '';
      for (var i = 0; i < cap; i++) {
        var id = items[i];
        if (id) {
          var f = byId[id];
          html += '<li class="lmp-box__slot is-full is-' + f.crop + (i === lastAdded ? ' is-new' : '') + '" style="--flavor:' + f.color + '">' +
            (f.img ? '<img src="' + f.img + '" alt="Sachet ' + f.name.replace(/"/g, '&quot;') + '" width="120" height="150">' : '') + '<i></i></li>';
        } else {
          var perk = i === FREE - 1 ? 'livraison offerte' : (i === BIG - 1 ? '2,79 € / sachet' : '');
          html += '<li class="lmp-box__slot">' + (perk ? '<span class="lmp-box__perk">' + perk + '</span>' : '<span class="lmp-visually-hidden">Case vide</span>') + '</li>';
        }
      }
      slots.innerHTML = html;
      var more = $('[data-more]');
      more.hidden = n <= BIG;
      more.textContent = '+ ' + (n - BIG) + ' sachets en plus';

      $$('[data-count]').forEach(function (el) { el.textContent = plural(n); });
      $$('[data-total]').forEach(function (el) { el.textContent = fmt(total); });
      $$('[data-total-was]').forEach(function (el) { el.textContent = off ? fmt(full) : ''; el.hidden = !off; });
      $$('[data-unit]').forEach(function (el) {
        var base = n ? Math.round(full / n) : 299;
        el.innerHTML = off ? '<s>' + fmt(base) + '</s> ' + fmt(base - off) : fmt(base);
      });

      // Tailles de box
      $$('[data-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(n === Number(b.dataset.size))); });

      // Parfums
      $$('[data-flavor]').forEach(function (row) {
        var id = row.dataset.flavor;
        var q = row.querySelector('[data-qty]');
        if (q) q.textContent = count(id);
        var d = row.querySelector('[data-dec]');
        if (d) d.disabled = count(id) === 0;
        row.querySelectorAll('[data-inc]').forEach(function (b) { b.disabled = !canAdd(id); });
      });

      // Paliers
      $$('.lmp-box__steps li').forEach(function (li) {
        var ok = n >= Number(li.dataset.k);
        li.classList.toggle('is-done', ok);
        li.querySelector('.lmp-box__dot').textContent = ok ? '✓' : li.dataset.k;
      });
      var ratio = Math.min(1, Math.max(0, (n - MIN) / (BIG - MIN)));
      var line = $('[data-line]');
      if (line) line.style.width = (ratio * 100).toFixed(1) + '%';
      var bar = n <= MIN ? n / MIN * 25 : (n <= FREE ? 25 + (n - MIN) / (FREE - MIN) * 25 : 50 + Math.min(1, (n - FREE) / (BIG - FREE)) * 50);
      var barFill = $('[data-bar-fill]');
      if (barFill) barFill.style.width = bar.toFixed(1) + '%';

      var next;
      if (n < MIN) next = 'Encore ' + plural(MIN - n) + ' pour pouvoir fermer la box';
      else if (n < FREE) next = 'Plus que ' + plural(FREE - n) + ' pour le point relais offert et 2,89 € le sachet';
      else if (n < BIG) next = 'Plus que ' + plural(BIG - n) + ' pour passer à 2,79 € le sachet';
      else next = 'Meilleur prix : 2,79 € le sachet, livraison offerte';
      $('[data-next]').textContent = next;

      // Livraison (le montant n'est affiché qu'à l'étape suivante, selon le poids et l'adresse)
      var ship, note, shipShort;
      if (n >= FREE) { ship = 'Offerte'; note = 'Offerte en point relais. À domicile, offerte dès 70 € d\'achat.'; shipShort = 'livraison offerte'; }
      else { ship = 'Calculée à l\'étape suivante'; note = '3,90 € en point relais, offerte dès 18 sachets. À domicile, offerte dès 70 €.'; shipShort = 'livraison calculée ensuite'; }
      $('[data-ship]').textContent = ship;
      $('[data-ship-note]').textContent = note;
      $('[data-bar-label]').textContent = plural(n) + ' · ' + shipShort;

      $$('[data-order]').forEach(function (b) {
        var ready = n >= MIN;
        b.disabled = !ready;
        if (b.closest('[data-bar]')) b.textContent = ready ? 'Fermer ma box' : 'Encore ' + (MIN - n);
        else b.textContent = ready ? 'Fermer ma box et commander' : 'Encore ' + plural(MIN - n) + ' pour valider';
      });
    }

    // Fenêtre « il reste de la place » : proposée quand il manque 1 à 3 sachets pour un palier
    var modal = $('[data-modal]');
    var modalAdd = [];
    function near() {
      var n = items.length;
      var gap = n < FREE ? FREE - n : (n < BIG ? BIG - n : 99);
      return n >= MIN && gap <= 3 ? gap : 0;
    }
    function favourite() {
      var best = null, bestC = -1;
      F.forEach(function (f) { var c = count(f.id); if (c > bestC && canAdd(f.id)) { best = f.id; bestC = c; } });
      return best;
    }
    function openModal(gap) {
      var n = items.length;
      var toFree = n < FREE;
      var add = [], tally = {};
      var fav = favourite();
      for (var i = 0; i < gap; i++) {
        var id = fav && count(fav) + (tally[fav] || 0) < byId[fav].max ? fav : null;
        if (!id) { var alt = available.filter(function (f) { return count(f.id) + (tally[f.id] || 0) < f.max; })[0]; id = alt && alt.id; }
        if (!id) break;
        add.push(id); tally[id] = (tally[id] || 0) + 1;
      }
      if (add.length < gap) return false;
      modalAdd = add;
      var after = n + gap;
      var before = items.reduce(function (s, id) { return s + byId[id].price; }, 0) - offOf(n) * n;
      var afterTotal = items.concat(add).reduce(function (s, id) { return s + byId[id].price; }, 0) - offOf(after) * after;
      root.querySelector('[data-m-title]').textContent = 'Plus que ' + plural(gap) + ' pour ' + (toFree ? 'la livraison offerte' : '2,79 € le sachet');
      root.querySelector('[data-m-text]').textContent = toFree
        ? 'Ajoutez-en ' + gap + ' : la livraison vous est offerte et chaque sachet passe à 2,89 €.'
        : 'Ajoutez-en ' + gap + ' : chaque sachet passe à 2,79 €.';
      root.querySelector('[data-m-add]').textContent = 'Ajouter ' + plural(gap) + ' · + ' + fmt(afterTotal - before);
      if (typeof modal.showModal === 'function') modal.showModal(); else return false;
      return true;
    }

    function checkout() {
      var err = $('[data-error]');
      err.hidden = true;
      var updates = {};
      F.forEach(function (f) { updates[f.variant] = count(f.id); });
      var buttons = $$('[data-order]');
      buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      fetch(data.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Erreur'); });
        // La box est gardée : si le client revient en arrière depuis le paiement, il la retrouve telle quelle
        window.location.href = data.checkout;
      }).catch(function (e) {
        err.textContent = 'Oups, la box n\'a pas pu être fermée : ' + e.message + ' Réessayez dans un instant.';
        err.hidden = false;
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
        render();
      });
    }

    function order() {
      if (items.length < MIN) return;
      var gap = near();
      if (gap && openModal(gap)) return;
      checkout();
    }

    // Événements
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;
      var row = t.closest('[data-flavor]');
      if (t.hasAttribute('data-inc') && row) return inc(row.dataset.flavor);
      if (t.hasAttribute('data-dec') && row) return dec(row.dataset.flavor);
      if (t.hasAttribute('data-sizenote-go')) { sizeNote(0); var fl = document.getElementById('lmp-box-flavors'); if (fl) fl.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (t.hasAttribute('data-sizenote-ok')) return sizeNote(0);
      if (t.dataset.size) { setItems(fill(Number(t.dataset.size), false)); return sizeNote(Number(t.dataset.size)); }      if (t.hasAttribute('data-surprise')) return setItems(fill(items.length < FREE ? FREE : items.length, true));
      if (t.hasAttribute('data-order')) return order();
      if (t.hasAttribute('data-m-add')) { modal.close(); var next = items.concat(modalAdd); setItems(next, items.length); return; }
      if (t.hasAttribute('data-m-anyway')) { modal.close(); return checkout(); }
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

    // Téléphone : la barre du bas s'efface quand le récapitulatif (même total, même bouton) est à l'écran,
    // ou quand on a quitté la box
    var summary = $('.lmp-box__summary');
    if (summary && $('[data-bar]') && 'IntersectionObserver' in window) {
      var sumVisible = false, boxVisible = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === summary) sumVisible = en.isIntersecting; else boxVisible = en.isIntersecting;
        });
        root.classList.toggle('is-bar-hidden', sumVisible || !boxVisible);
      });
      io.observe(summary);
      io.observe(root);
    }

    var saved = load();
    // Arrivée depuis une fiche produit : ?ajout=handle:quantité → ces sachets s'ajoutent à la box en cours
    // Arrivée depuis une carte de l'accueil : ?pack=5|12|18|24 → la box est préremplie à cette taille
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) {}
    var ajout = params ? params.get('ajout') : null;
    var pack = params ? parseInt(params.get('pack'), 10) : 0;
    var addId = ajout ? ajout.split(':')[0] : '';
    if (addId && byId[addId]) {
      var addQty = Math.max(1, Math.min(30, parseInt(ajout.split(':')[1], 10) || 1));
      items = saved && saved.length ? saved : [];
      for (var k = 0; k < addQty; k++) { if (canAdd(addId)) items.push(addId); }
      lastAdded = items.length - 1;
      save();
      try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
    } else if ([5, 12, 18, 24].indexOf(pack) !== -1) {
      items = fill(pack, false);
      save();
      try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
    } else {
      items = saved && saved.length ? saved : fill(FREE, false);
    }
    render();

    // Arrivée depuis le panier (icône panier du paiement) : ?panier=1 → la box reprend le contenu réel du panier
    if (params && params.get('panier')) {
      try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var next = [];
        (cart.items || []).forEach(function (it) {
          var f = F.filter(function (x) { return String(x.variant) === String(it.variant_id); })[0];
          for (var q = 0; f && q < it.quantity && next.length < 60; q++) next.push(f.id);
        });
        if (next.length) { items = next; lastAdded = -1; save(); render(); }
      }).catch(function () {});
    }

    // Retour arrière depuis le paiement : le navigateur restaure la page telle qu'on l'a quittée (boutons grisés).
    // On réactive les boutons ; la box, elle, est intacte.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      $$('[data-order]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      render();
    });
  }

  function boot() { document.querySelectorAll('[data-lmp-box]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
